import {Controller} from "stimulus"
import $ from 'jquery';
import I18n from "i18n-js";
import flatpickr from "flatpickr";
import {Spanish} from "flatpickr/dist/l10n/es";


export default class extends Controller {

    connect() {
        flatpickr("#offert_from", {
            altInput: true,
            altFormat: "d-m-Y H:i",
            dateFormat: "Y-m-d H:i",
            minDate: new Date().setHours(new Date().getHours() - 1),
            locale: Spanish,
            enableTime: true,
            time_24hr: true,
            disableMobile: "true"
        });
        flatpickr("#offert_to", {
            altInput: true,
            altFormat: "d-m-Y H:i",
            dateFormat: "Y-m-d H:i",
            minDate: new Date().setHours(new Date().getHours() - 1),
            locale: Spanish,
            enableTime: true,
            time_24hr: true,
            disableMobile: "true"
        });

        let check_apply = $('#offert_apply_all')
        let agencies = $('#agencies')
        check_apply.on('change', (e) => {
            if(check_apply[0].checked){
                agencies[0].classList.add('ocultar')
            }else{
                agencies[0].classList.remove('ocultar')
            }
        })

        let offert_image = $('#offert_image')
        let previewImage = $('#previewImage')
        offert_image.on('change', (event) => {
            const file = event.target.files[0]
            if (!file.type.match('image.*')) {
                alert('Error: Por favor selecciona un archivo de imagen válido (JPG, PNG, GIF, WebP, SVG).');
                imageInput.value = ''; // Limpiar el input
                return;
            }

            // Validar tamaño máximo (5 MB)
            const maxSize = 5 * 1024 * 1024; // 5 MB en bytes
            if (file.size > maxSize) {
                alert('Error: El archivo es demasiado grande. El tamaño máximo permitido es 5 MB.');
                imageInput.value = ''; // Limpiar el input
                return;
            }

            // Crear un objeto URL para la imagen
            const imageURL = URL.createObjectURL(file);
            // Configurar la imagen de vista previa
            previewImage.onload = function() {
                // Liberar el objeto URL cuando ya no sea necesario
                URL.revokeObjectURL(imageURL);
            };

            // Si hay un error al cargar la imagen
            previewImage.onerror = function() {
                alert('Error: No se pudo cargar la imagen seleccionada.');
                imageInput.value = ''; // Limpiar el input
            };

            // Asignar la URL de la imagen al src del elemento img
            previewImage[0].src = imageURL;

        })
    }

}